// extracted by mini-css-extract-plugin
module.exports = {"root":"mIndex_root__R33tQ","title":"mIndex_title__oAfoP","actions":"mIndex_actions__H6ihn"};